import React, { useState, useEffect } from 'react';
import { TextField } from '@mui/material';

const ControlledTextField = React.memo(({
                                            label,
                                            type,
                                            name,
                                            value,
                                            style,
                                            autoComplete,
                                            onChange,
                                            inputProps,
                                            disabled,
                                            pattern,
                                            multiline,
                                            rows,
                                            fullWidth,
                                        }) => {
    const [localValue, setLocalValue] = useState(value);

    useEffect(() => {
        setLocalValue(value);
    }, [value]);

    const handleChange = (e) => {
        if (pattern && !(new RegExp(pattern).test(e.target.value))) return;
        setLocalValue(e.target.value);
        if (e.target.value === '') {
            onChange(e);
        }
    };

    const handleBlur = () => {
        onChange({ target: { name, value: localValue } });
    };

    return (
        <TextField
            name={name}
            onChange={handleChange}
            onBlur={handleBlur}
            label={label}
            type={type}
            value={localValue}
            style={style}
            autoComplete={autoComplete}
            inputProps={inputProps}
            disabled={disabled}
            multiline={multiline}
            rows={rows}
            fullWidth={fullWidth}
        />
    );
});

export default ControlledTextField;
